const WIDGET_TOKEN_STORAGE_KEY = 'widgetToken'

function decodeJWT(token: string): any | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null

    const payload = parts[1]
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decoded)
  } catch (error) {
    console.error('Failed to decode JWT token:', error)
    return null
  }
}

function isJWTExpired(token: string): boolean {
  const payload = decodeJWT(token)
  if (!payload || !payload.exp) return true

  const currentTime = Math.floor(Date.now() / 1000)
  return currentTime >= payload.exp
}

export function getWidgetToken(): string | null {
  if (!window?.localStorage) return null

  const token = localStorage.getItem(WIDGET_TOKEN_STORAGE_KEY)
  if (!token) return null

  if (isJWTExpired(token)) {
    console.warn('JWT token expired')
    return null
  }

  return token
}

export function setWidgetToken(token: string): void {
  if (!window?.localStorage || !token) return
  localStorage.setItem(WIDGET_TOKEN_STORAGE_KEY, token)
}
